var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.33334C9.01377 1.33334 3.33331 6.95731 3.33331 13.9157C3.33331 18.0596 5.46239 21.6689 7.79948 24.3985C10.1511 27.1451 12.8455 29.1565 14.2692 30.1292C15.318 30.8458 16.682 30.8458 17.7308 30.1292C19.1545 29.1565 21.8488 27.1451 24.2005 24.3985C26.5376 21.6689 28.6666 18.0596 28.6666 13.9157C28.6666 6.95731 22.9862 1.33334 16 1.33334Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 14,
    r: 4,
    fill: "white",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressPin);
export default __webpack_public_path__ + "static/media/AddressPin.3493eb3b8da651faf82855d7492f0092.svg";
export { ForwardRef as ReactComponent };